import { render, staticRenderFns } from "./reset-password-dialog.vue?vue&type=template&id=59fb97de"
import script from "./reset-password-dialog.vue?vue&type=script&lang=ts"
export * from "./reset-password-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports